module.exports = __webpack_public_path__ + "img/file.3792baa8.svg";